import Serissa1 from '../Serissa/Serissa (1).webp'
import Serissa2 from '../Serissa/Serissa (2).webp'
import Serissa3 from '../Serissa/Serissa (3).webp'
import Serissa4 from '../Serissa/Serissa (4).webp'
import Serissa5 from '../Serissa/Serissa (5).webp'
import Serissa6 from '../Serissa/Serissa (6).webp'
import Serissa7 from '../Serissa/Serissa (7).webp'
import Serissa8 from '../Serissa/Serissa (8).webp'
import Serissa9 from '../Serissa/Serissa (9).webp'
import Serissa10 from '../Serissa/Serissa (10).webp'

const Serissaimages =[
Serissa1,Serissa2,Serissa3,Serissa4,Serissa5,Serissa6,Serissa7,Serissa8,Serissa9,Serissa10
]

export default Serissaimages;